"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelStoreProvider = exports.ModelStoreContext = void 0;
exports.getModelPrimaryKey = getModelPrimaryKey;
exports.initModelRecord = initModelRecord;
var _react = _interopRequireWildcard(require("react"));
var _fetchJson = require("../fetchJson");
var _nats = require("../nats.js");
var _warnonce = require("../warnonce");
var _modelStoreReducer = require("./modelStoreReducer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// store.js

// Inspiration for the ref-based store taken from https://www.youtube.com/watch?v=ZKlXqrcBx88

const JSONCodec = (0, _nats.JSONCodec)();

// Unfortunately, NATS types aren't working because we copied nats.js into here manually since the nats.ws package isn't
// working.
// Types of credentials the server could send us
const models = {
  acc_item: {
    primaryKey: 'id',
    __type: {}
  },
  acc_purchase_order: {
    primaryKey: 'id',
    __type: {}
  },
  acc_purchase_order_item: {
    primaryKey: 'id',
    __type: {}
  },
  account: {
    primaryKey: 'id',
    __type: {}
  },
  attachment: {
    primaryKey: 'id',
    __type: {}
  },
  bank_transaction: {
    primaryKey: 'id',
    __type: {}
  },
  bom_operation: {
    primaryKey: 'id',
    __type: {}
  },
  bom_operation_item: {
    primaryKey: 'id',
    __type: {}
  },
  box: {
    primaryKey: 'id',
    __type: {}
  },
  company: {
    primaryKey: 'id',
    __type: {}
  },
  company_exempt_form: {
    primaryKey: 'id',
    __type: {}
  },
  coupon: {
    primaryKey: 'id',
    __type: {}
  },
  credit_note: {
    primaryKey: 'id',
    __type: {}
  },
  customer: {
    primaryKey: 'id',
    __type: {}
  },
  customer_account_ledger: {
    primaryKey: 'id',
    __type: {}
  },
  customer_user: {
    primaryKey: 'id',
    __type: {}
  },
  cut_condition: {
    primaryKey: 'id',
    __type: {}
  },
  earned_revenue: {
    primaryKey: 'startTimestamp',
    __type: {}
  },
  event: {
    primaryKey: 'id',
    __type: {}
  },
  facility: {
    primaryKey: 'id',
    __type: {}
  },
  gl_header: {
    primaryKey: 'id',
    __type: {}
  },
  gl_item: {
    primaryKey: 'id',
    __type: {}
  },
  holiday: {
    primaryKey: 'id',
    __type: {}
  },
  item_inventory: {
    primaryKey: 'id',
    __type: {}
  },
  item_inventory_ledger: {
    primaryKey: 'id',
    __type: {}
  },
  item_inventory_location: {
    primaryKey: 'id',
    __type: {}
  },
  label_part: {
    primaryKey: 'id',
    __type: {}
  },
  label: {
    primaryKey: 'id',
    __type: {}
  },
  leadin_presets: {
    primaryKey: 'id',
    __type: {}
  },
  machine: {
    primaryKey: 'id',
    __type: {}
  },
  machine_state_aggregate: {
    primaryKey: 'id',
    __type: {}
  },
  material: {
    primaryKey: 'id',
    __type: {}
  },
  // This is a "pseudo" model formed by joining the materials types and sheets
  material_inventory: {
    primaryKey: 'id',
    __type: {}
  },
  material_ledger: {
    primaryKey: 'id',
    __type: {}
  },
  material_type: {
    primaryKey: 'material_id',
    __type: {}
  },
  material_sheet: {
    primaryKey: 'id',
    __type: {}
  },
  material_sheet_condition: {
    primaryKey: 'id',
    __type: {}
  },
  material_sheet_condition_measurement: {
    primaryKey: 'id',
    __type: {}
  },
  material_study: {
    primaryKey: 'id',
    __type: {}
  },
  material_study_sheet: {
    primaryKey: 'id',
    __type: {}
  },
  material_tube: {
    primaryKey: 'id',
    __type: {}
  },
  move_event_document: {
    primaryKey: 'id',
    __type: {}
  },
  nest_part: {
    primaryKey: 'id',
    __type: {}
  },
  nest_part_pose: {
    primaryKey: 'id',
    __type: {}
  },
  nest_sheet: {
    primaryKey: 'id',
    __type: {}
  },
  nest_sheet_denest: {
    primaryKey: 'id',
    __type: {}
  },
  npp_denest: {
    primaryKey: 'id',
    __type: {}
  },
  note: {
    primaryKey: 'id',
    __type: {}
  },
  operation: {
    primaryKey: 'id',
    __type: {}
  },
  order: {
    primaryKey: 'id',
    __type: {}
  },
  order_calendar: {
    primaryKey: 'id',
    __type: {}
  },
  order_cost_detail: {
    primaryKey: 'id',
    __type: {}
  },
  order_part: {
    primaryKey: 'id',
    __type: {}
  },
  part: {
    primaryKey: 'id',
    __type: {}
  },
  part_program: {
    primaryKey: 'id',
    __type: {}
  },
  permission_group: {
    primaryKey: 'id',
    __type: {}
  },
  process: {
    primaryKey: 'id',
    __type: {}
  },
  powder: {
    primaryKey: 'id',
    __type: {}
  },
  powder_job: {
    primaryKey: 'id',
    __type: {}
  },
  powder_part: {
    primaryKey: 'id',
    __type: {}
  },
  purchase_order: {
    primaryKey: 'id',
    __type: {}
  },
  purchase_order_item: {
    primaryKey: 'id',
    __type: {}
  },
  pipe_status: {
    primaryKey: 'work_order_item_id',
    __type: {}
  },
  rem_denest: {
    primaryKey: 'id',
    __type: {}
  },
  resource_lock: {
    primaryKey: 'resource_id',
    __type: {}
  },
  sales_invoice: {
    primaryKey: 'id',
    __type: {}
  },
  sales_invoice_item: {
    primaryKey: 'id',
    __type: {}
  },
  scrap_record: {
    primaryKey: 'id',
    __type: {}
  },
  settings: {
    primaryKey: 'id',
    __type: {}
  },
  shipment: {
    primaryKey: 'id',
    __type: {}
  },
  shipment_item: {
    primaryKey: 'id',
    __type: {}
  },
  shipment_label: {
    primaryKey: 'id',
    __type: {}
  },
  shipping_order: {
    primaryKey: 'id',
    __type: {}
  },
  shipping_order_item: {
    primaryKey: 'id',
    __type: {}
  },
  supplier_sheet: {
    primaryKey: 'id',
    __type: {}
  },
  supplier: {
    primaryKey: 'id',
    __type: {}
  },
  sync_counter: {
    primaryKey: 'id',
    __type: {}
  },
  taps: {
    primaryKey: 'thread',
    __type: {}
  },
  task: {
    primaryKey: 'id',
    __type: {}
  },
  time_tracking: {
    primaryKey: 'id',
    __type: {}
  },
  training: {
    primaryKey: 'id',
    __type: {}
  },
  training_event: {
    primaryKey: 'id',
    __type: {}
  },
  training_covered_in_event: {
    primaryKey: 'id',
    __type: {}
  },
  training_event_attendee: {
    primaryKey: 'id',
    __type: {}
  },
  training_group_user: {
    primaryKey: 'id',
    __type: {}
  },
  training_group: {
    primaryKey: 'id',
    __type: {}
  },
  training_group_requirement: {
    primaryKey: 'id',
    __type: {}
  },
  transaction_old: {
    primaryKey: 'id',
    __type: {}
  },
  transaction: {
    primaryKey: 'id',
    __type: {}
  },
  transaction_item: {
    primaryKey: 'id',
    __type: {}
  },
  tube_laser_job: {
    primaryKey: 'id',
    __type: {}
  },
  tube_laser_job_item_inventory: {
    primaryKey: 'id',
    __type: {}
  },
  tube_laser_job_order_part: {
    primaryKey: 'id',
    __type: {}
  },
  tube_laser_job_remainder: {
    primaryKey: 'id',
    __type: {}
  },
  user: {
    primaryKey: 'id',
    __type: {}
  },
  vendor: {
    primaryKey: 'id',
    __type: {}
  },
  vendor_item: {
    primaryKey: 'id',
    __type: {}
  },
  work_order_item: {
    primaryKey: 'id',
    __type: {}
  },
  work_order: {
    primaryKey: 'id',
    __type: {}
  },
  workstation: {
    primaryKey: 'id',
    __type: {}
  }
};
function getModelPrimaryKey(modelName) {
  return models[modelName].primaryKey;
}
function initModelRecord(initValueFn) {
  return Object.keys(models).reduce((a, c) => {
    a[c] = initValueFn();
    return a;
  }, {});
}
const initialModel = {
  signatureStatus: {},
  // for each request signature (apiPath + params), whether it is pending or complete. 
  endpointState: {},
  // for each request signature without keys (apiPath + (params without keys)), a list of retrieved keys. Use to modify requests, filtering out keys that have already been retrieved.
  model: initModelRecord(() => []),
  modelUpdateCount: initModelRecord(() => null),
  modelSyncErrorCount: initModelRecord(() => 0),
  subscribedModels: [],
  subscribedTables: [],
  lostSynch: false,
  authorizationFailed: false,
  natsConnected: false,
  requestQueue: [],
  // a list of objects, each containing an endpoint, signature, and status
  numberOfSubscribersByModel: initModelRecord(() => 0),
  numberOfSubscribersByTable: initModelRecord(() => 0),
  statistics: {
    retrievals: {
      pending: 0,
      complete: 0
    },
    mutations: {
      pending: 0,
      complete: 0
    }
  }
};
function useModelStoreData(natsAuthEndpoint) {
  // console.log('useModelStoreData')

  /** Set of subscribers of each model. Each item is a callback function for that subscriber. */
  const subscribers = (0, _react.useRef)(initModelRecord(() => new Set()));

  /** Set of internal state subscribers. Each item is a callback function for that subscriber. */
  const internalSubscribers = (0, _react.useRef)(new Set());

  /** The model state, plus additional things which may be of interest to subscribers. */
  const state = (0, _react.useRef)(initialModel);

  /** Returns the current state of the model store. */
  const getState = (0, _react.useCallback)(() => state.current, []);

  /**
   * Requests data from the server.
   * @param endpoint The endpoint to request data from.
   * @param signature The endpoint signature.
   */
  const requestData = (0, _react.useCallback)((endpoint, signature) => {
    dispatch({
      type: 'queueRequest',
      endpoint,
      signature
    });
  }, []);

  /**
   * Updates data on the server, and updates the model.
   * @param constructedEndpoint A constructed endpoint to update data on.
   * @returns A promise which resolves with the updated data.
   */
  async function requestMutation(constructedEndpoint) {
    if (!constructedEndpoint.params) {
      throw new Error('Mutation object must have a params property.');
    }
    dispatch({
      type: 'mutationRequestBegin'
    });
    let response;
    try {
      response = await constructedEndpoint.execute(constructedEndpoint.params);
    } catch (ex) {
      throw ex;
    } finally {
      // Ensure this always runs because we need to keep count of how many mutation requests are in flight
      dispatch({
        type: 'mutationRequestEnd'
      });
    }
    if (!response.result) {
      throw new Error('No `result` property in response');
    }
    for (let updateItem of response.result) {
      if (!updateItem.model) {
        throw new Error('No `result.model` property in response');
      }
      let model = updateItem.model;
      // Verify model is contained in primary keys
      if (!models[model]) {
        (0, _warnonce.warnonce)(`Model ${model} is not recognized.`);
        continue;
      }
      // serverUpdateCount is unknown, but we should still receive a socket update with the correct value.
      dispatch({
        type: 'updateModel',
        model,
        data: updateItem.data,
        operation: updateItem.operation,
        serverUpdateCount: null
      });
    }
    return response;
  }

  /**
   * Updates data on the server, and updates the model.
   * @param constructedEndpoint A constructed endpoint to update data on.
   * @returns A promise which resolves with the updated data.
   */
  const requestMutationCallback = (0, _react.useCallback)(requestMutation, []);

  /**
   * Update the state and notify subscribers.
   * @param actions An action or actions used to update the state.
   */
  const dispatch = (0, _react.useCallback)(actions => {
    if (!Array.isArray(actions)) actions = [actions];

    // Apply all actions
    let newState = state.current;
    for (let action of actions) {
      newState = (0, _modelStoreReducer.modelStoreReducer)(newState, action);
    }

    // Has the state changed?
    if (newState !== state.current) {
      state.current = newState;
      if (actions.some(action => action.type === 'queueRequest')) {
        processRequestQueue();
      }

      // Notify subscribers if the model has changed
      for (let action of actions) {
        if (action.type === 'updateModel') {
          notifySubscribers(action.model);
        }
      }
      notifyInternalSubscribers();
    }
  }, []);

  /**
   * Subscribe to changes in a model.
   * @param model The model to subscribe to.
   * @param callback The callback function to call when the model is updated.
   * @returns A function to unsubscribe.
   */
  const subscribe = (0, _react.useCallback)((model, callback) => {
    subscribers.current[model].add(callback);
    dispatch({
      type: 'setNumberOfSubscribersByModel',
      model,
      numberOfSubscribers: subscribers.current[model].size
    });
    return () => {
      subscribers.current[model].delete(callback);
      dispatch({
        type: 'setNumberOfSubscribersByModel',
        model,
        numberOfSubscribers: subscribers.current[model].size
      });
    };
  }, []);

  /**
   * Subscribes to changes in the model store internal state.
   * @param callback The callback function to call when the internal state is updated.
   * @returns A function to unsubscribe.
   */
  const internalStateSubscribe = (0, _react.useCallback)(callback => {
    internalSubscribers.current.add(callback);
    // Do not dispatch actions here, or it could create an infinite re-render loop with consumers
    return () => {
      internalSubscribers.current.delete(callback);
    };
  }, []);

  /**
   * Notify subscribers of a change to a model.
   * @param model The model that was updated.
   */
  const notifySubscribers = (0, _react.useCallback)(model => {
    // console.log(`notifySubscribers: ${model} (there are ${subscribers.current[model].size} subscribers)`)
    subscribers.current[model].forEach(callback => callback());
  }, []);

  /**
   * Notify subscribers of a change to the internal state.
   */
  const notifyInternalSubscribers = (0, _react.useCallback)(() => {
    internalSubscribers.current.forEach(callback => callback());
  }, []);
  const refNatsConnection = (0, _react.useRef)();
  const refNatsSubscriptionRequests = (0, _react.useRef)([]);

  // Used to ensure that requests are not fired more than once
  const requestsFired = (0, _react.useRef)([]);

  /**
   * Process the request queue.
   */
  function processRequestQueue() {
    // console.log('processRequestQueue')
    if (!state.current.natsConnected) {
      // Don't process the queue yet. Once nats is connected, this function will be called again.
      return;
    }
    state.current.requestQueue.forEach(req => {
      // Last chance to bail out if this request has already been made
      if (requestsFired.current.includes(req.signature)) {
        // Only dequeue the request if the state reflects that it is complete. Otherwise, it's possible to enter an infinite
        // queue/dequeue loop that slows everything down to a crawl when there are many pending requests.
        if (state.current.signatureStatus[req.signature] === 'complete') {
          dispatch({
            type: 'dequeueRequest',
            signature: req.signature
          });
        }
        return;
      }

      // Ensure we do not repeat this request again
      requestsFired.current.push(req.signature);
      if (!req.endpoint.apiPath) {
        throw new Error(`Cannot perform request for endpoint because it does not have an apiPath property. This should never happen because apiPath properties are added at the end of defaultApi.ts`);
      }
      if (!req.endpoint.model) {
        throw new Error('Cannot perform request for endpoint because it does not have a model property. This should never happen because only endPoints that have a model property can be queued using useModel');
      }
      let model = req.endpoint.model;

      // If endpoint.key is set, check to see if we have requested data for that key already. If not, alter the params
      // to only request the data for the missing keys.
      let requestParams = req.endpoint.params;
      if (req.endpoint.key) {
        var _state$current$endpoi, _state$current$endpoi2;
        // If the endpoint has other params which affect the data returned, we don't want to filter out the keys unless the other params match.
        let {
          [req.endpoint.key]: requestedKeys,
          ...paramsWithoutKey
        } = req.endpoint.params;
        let signatureWithoutKeys = req.endpoint.apiPath + JSON.stringify(paramsWithoutKey);
        if (!Array.isArray(requestedKeys)) {
          throw new Error(`In endpoint ${req.endpoint.apiPath}, expected param['${req.endpoint.key}'] to be an array. Instead, got ${requestedKeys}. Check the endpoint's key property, and make sure you are passing an array of keys to the request.`);
        }
        // console.log(`requestedKeys:`, requestedKeys)
        let presentKeys = (_state$current$endpoi = (_state$current$endpoi2 = state.current.endpointState[signatureWithoutKeys]) === null || _state$current$endpoi2 === void 0 ? void 0 : _state$current$endpoi2.retrievedKeys) !== null && _state$current$endpoi !== void 0 ? _state$current$endpoi : [];
        // console.log(`presentKeys:`, presentKeys)
        if (presentKeys.length > 0) {
          let missingKeys = [];
          for (let key of requestedKeys) {
            if (key == null) {
              throw new Error(`A key with a value if ${key} was requested. Please check the endpoint definition for ${req.endpoint.apiPath}.`);
            }
            if (!presentKeys.includes(key)) {
              missingKeys.push(key);
            }
          }
          // console.log(`missingKeys:`, missingKeys)
          if (missingKeys.length > 0) {
            requestParams = {
              ...requestParams,
              [req.endpoint.key]: missingKeys
            };
          } else {
            // All keys are present, so don't bother making the request. Set status as complete so we can skip this check next time.
            dispatch([{
              type: 'setSignatureStatus',
              signature: req.signature,
              status: 'complete'
            }, {
              type: 'dequeueRequest',
              signature: req.signature
            }]);
            return;
          }
        }
      }

      // Make the request
      dispatch([{
        type: 'setSignatureStatus',
        signature: req.signature,
        status: 'pending'
      }, {
        type: 'retrievalRequestBegin'
      }]);

      // Subscribe as soon as possible. This way, we can be sure that we don't miss any updates.
      subscribeToModel(model);
      req.endpoint.execute(requestParams).then(response => {
        const responseAsArray = Array.isArray(response) ? response : [response];
        // serverUpdateCount is not currently included in the response
        // These MUST be updated simultaneously, because consumers will check the signature status to determine if
        // the model is ready to be used.
        dispatch([{
          type: 'updateModel',
          model,
          data: responseAsArray,
          serverUpdateCount: null
        }, {
          type: 'setSignatureStatus',
          signature: req.signature,
          status: 'complete'
        }]);
        // Save these retrieved keys.
        if (req.endpoint.key) {
          let {
            [req.endpoint.key]: keys,
            ...paramsWithoutKey
          } = req.endpoint.params;
          let signatureWithoutKeys = req.endpoint.apiPath + JSON.stringify(paramsWithoutKey);
          if (!Array.isArray(keys)) {
            keys = [keys];
          }
          dispatch({
            type: 'addRetrievedKeys',
            signatureWithoutKeys,
            keys
          });
        }
      })
      // TODO: More error handling
      .catch(e => {
        if (e.serverMessage && e.serverMessage.match(/Not authorized/)) {
          dispatch({
            type: 'authorizationFailed'
          });
        }
      }).finally(() => {
        // Ensure this always gets called, because we must keep count
        dispatch([{
          type: 'retrievalRequestEnd'
        }, {
          type: 'dequeueRequest',
          signature: req.signature
        }]);
      });
    });
  }

  /**
   * Subscribe to NATS updates for the given model.
   * @param model The model to subscribe to.
   */
  function subscribeToModel(model) {
    if (!refNatsSubscriptionRequests.current.includes(model)) {
      refNatsSubscriptionRequests.current.push(model);
      let subject = `model.${model}`;
      let sub = refNatsConnection.current.subscribe(subject);
      handleNatsSubscription(sub);
      dispatch({
        type: 'subscribe',
        model
      });
      console.log('Subscribed to nats topic:', subject);
    }
  }

  /**
   * Process messages from a NATS subscription.
   * @param sub The subscription to process.
   */
  async function handleNatsSubscription(sub) {
    for await (let msg of sub) {
      handleNatsMessage(msg);
    }
    console.log('Unsubscribed from nats topic:', sub.subject);
  }

  /**
   * Dispatch data updates that come from NATS messages.
   * @param msg The message to process.
   */
  function handleNatsMessage(msg) {
    let data = JSONCodec.decode(msg.data);
    if (data.delete) {
      dispatchData(data.delete, true);
    } else if (data.update) {
      dispatchData(data.update);
    } else if (data.create) {
      dispatchData(data.create);
    }
  }

  /**
   * Helper function to dispatch data updates.
   * @param obj The data to dispatch.
   * @param deleted Whether the data is being deleted.
   */
  function dispatchData(obj, deleted = false) {
    // console.log('dispatchData', obj)

    for (let i in obj.data) {
      let model = obj.data[i].model;

      // Verify model is recognized
      if (!models[model]) {
        (0, _warnonce.warnonce)(`Model ${model} is not recognized.`);
        continue;
      }
      let data = obj.data[i];
      if (deleted && 'ids' in data) {
        dispatch({
          type: 'updateModel',
          model,
          data: data.ids,
          operation: 'delete',
          serverUpdateCount: data.total_updates
        });
      } else if (!deleted && 'objects' in data) {
        dispatch({
          type: 'updateModel',
          model,
          data: data.objects,
          serverUpdateCount: data.total_updates
        });
      } else {
        (0, _warnonce.warnonce)(`Received unrecognized data from server: ${JSON.stringify(data)}`);
      }
    }
  }

  /**
   * Initialize NATS and begin processing messages.
   */
  async function initialize() {
    //Reset this back to true in case this initialization is happening after a user logs back in
    dispatch({
      type: 'authorizationSuccess'
    });
    console.log('Retrieving NATS credentials');
    try {
      // Retrieve credentials from the rest server and connect to NATS
      let creds = await (0, _fetchJson.fetchPost)(natsAuthEndpoint);
      if (creds.auth) {
        switch (creds.nats_auth_type) {
          case 'password':
            refNatsConnection.current = await (0, _nats.connect)({
              servers: creds.nats_client_servers,
              user: creds.nats_client_user,
              pass: creds.nats_client_password,
              maxReconnectAttempts: -1,
              // No limit
              waitOnFirstConnect: true // Block until connected
            });

            break;
          default:
            throw new Error('Unrecognized authentication method: ' + creds.nats_auth_type);
        }
      }
      if (refNatsConnection.current) {
        console.log('NATS connected');
        dispatch({
          type: 'natsConnect'
        });

        // Begin processing the request queue
        processRequestQueue();

        // Normally we don't initially subscribe to anything, but you can uncomment for testing
        // const sub = connection.subscribe('model.>')
        // for await (const msg of sub) {
        //   console.log(msg)
        // }
      }

      // Monitor NATS connection status
      for await (let status of refNatsConnection.current.status()) {
        console.log(`NATS status: ${JSON.stringify(status)}`);
        if (status.type === 'disconnect') {
          dispatch({
            type: 'natsDisconnect'
          });
        }
        if (status.type === 'reconnect') {
          dispatch({
            type: 'natsConnect'
          });
        }
      }
    } catch (ex) {
      console.error(ex);
    }
  }

  /**
   * Drain and close the NATS connection.
   */
  function cleanup() {
    if (refNatsConnection.current) {
      refNatsConnection.current.drain()
      //Sometimes, the connection is already closed and throws an error when `drain` is called.
      .catch(ex => {
        console.error(ex);
      });
    }
  }

  /**
   * Effect to run the initialization and cleanup functions.
   */
  (0, _react.useEffect)(() => {
    initialize();
    return cleanup;
  }, []);
  return {
    getState,
    requestData,
    requestMutation: requestMutationCallback,
    subscribe,
    internalStateSubscribe
  };
}

/** A React context for holding the ModelStoreData */
const ModelStoreContext = exports.ModelStoreContext = /*#__PURE__*/(0, _react.createContext)(null);
/**
 * Provides the ModelStoreContext to the component tree
 * @param props
 * @param props.children The component tree to provide the context to.
 * @param props.natsAuthEndpoint Endpoint on the rest server that can respond with credentials to connect to the NATS server.
 * @returns The component tree with the context provided. 
 */
const ModelStoreProvider = ({
  children,
  natsAuthEndpoint
}) => {
  const modelStoreData = useModelStoreData(natsAuthEndpoint);
  return /*#__PURE__*/_react.default.createElement(ModelStoreContext.Provider, {
    value: modelStoreData
  }, children);
};
exports.ModelStoreProvider = ModelStoreProvider;